export const PRE_VERIFY_SECURITY_QUESTION_ACTION = "password-reset/PRE_VERIFY_SECURITY_QUESTION_ACTION";

export default function preVerifySecurityQuestionAction() {
  return {
    "type": PRE_VERIFY_SECURITY_QUESTION_ACTION
  };
}
